<template lang="">
  <div class="container">
    <img :src="icon">
    <div class="message">
      {{ text }}
    </div>
    <ms-button
      v-if="showBack"
      @click="onBack"
    >
      {{ $t('Button.Back') }}
    </ms-button>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: null
    },

    isSearch: {
      type: Boolean,
      default: false
    },

    /**
     * Có show nút back không
     */
    showBack: {
      type: Boolean,
      default: false
    },

    /**
     * Có show nút back không
     */
    showHeader: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      iconEmpty: require('@/assets/images/mascot/empty.svg'),
      iconNotFound: require('@/assets/images/mascot/not-found.svg')
    }
  },

  computed: {
    /**
     * icon
     */
    icon () {
      const me = this
      return me.isSearch ? me.iconNotFound : me.iconEmpty
    },

    /**
     * text hiển thị
     */
    text () {
      const me = this

      if (me.message !== '' && !me.message) {
        return me.isSearch ? me.$t('Common.SearchEmpty') : me.$t('Common.DataEmpty')
      }

      return me.message
    }
  },

  // watch: {
  //   showHeader (newVal) {
  //     const me = this

  //     if (me.newVal && me.$route.meta.excludeHeader) {
  //       me.$route.query.showHeader = true
  //     }
  //   }
  // },

  methods: {
    /**
     * @author PVThang
     * @description xử lý ấn nút back
     */
    onBack () {
      this.$router.go(-1)
    }
  },

  created () {
    const me = this
    if (me.showHeader && !me.$route.meta.excludeHeader) {
      me.$router.replace({
        query: { ...me.$route.query, showHeader: 'true' }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;

  .message {
    font-size: $font-size-title;
    line-height: $line-height-title;
    color: $color-neutral-light-4;
  }

  .ms-button {
    margin: 0;
    width: 156px;
  }
}
</style>
